import { EditLOSV3EventPage } from "./EditLOSV3EventPage";

export default EditLOSV3EventPage;
